import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Howl } from '../../../node_modules/howler/dist/howler.core.min.js';
import { browserRefresh } from '../app.component';
import { isPlatformBrowser } from '@angular/common';
import Hls from 'hls.js';
export class PlayerComponent {
    constructor(platformId, SpinnerService, router, route, homeService, commonService, toaster, playerService, authenticationService, titleService, metaService, doc) {
        this.platformId = platformId;
        this.SpinnerService = SpinnerService;
        this.router = router;
        this.route = route;
        this.homeService = homeService;
        this.commonService = commonService;
        this.toaster = toaster;
        this.playerService = playerService;
        this.authenticationService = authenticationService;
        this.titleService = titleService;
        this.metaService = metaService;
        this.doc = doc;
        this.refresh = true;
        this.SlideOptions = { items: 4, dots: false,
            responsive: {
                0: {
                    items: 2
                },
                350: {
                    items: 2
                },
                370: {
                    items: 3
                },
                400: {
                    items: 3
                },
                740: {
                    items: 4
                },
                940: {
                    items: 8
                },
                1400: {
                    items: 8
                }
            }, nav: true, navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'], };
        this.activetrack = null;
        this.player = null;
        this.lastPlayer = null;
        this.isplaying = false;
        this.stationId = null;
        this.lasttrack = null;
        this.commenttexterr = null;
        this.isfav = false;
        this.lastTrack = null;
        this.isloading = true;
        this.isDisabled = true;
        this.isplayerror = false;
        this.ispageload = false;
        this.volume = 0;
        this.bvolume = 0;
        this.ngvolume = 100;
        this.isMobile = false;
        this.playstate = false;
        this.alldata = [];
        this.isprevNext = false;
        this.isprevNextplaying = false;
        this.currentinprogress = [];
        this.hls = null;
        this.audio = null;
    }
    ngOnInit() {
        this.ngOn();
        var position;
        this.listingData();
        // alert("browserRefresh"+browserRefresh);
        // if(!browserRefresh){
        //   location.reload();
        //    // this.router.navigate([this.router.url])
        //   }
    }
    ngOn() {
        this.SpinnerService.show();
        ////console.log('stationame',this.route.snapshot.params.stationame);
        if (this.route.snapshot.params.stationame) {
            // console.log('this.route.snapshot.params.stationame', this.route.snapshot.params.stationame);
            // var str = this.route.snapshot.params.stationame.split('-').pop(); // returns 456
            // str = str.split("-"); 
            // this.stationSlug  = str[str.length - 1]; 
            this.stationSlug = this.route.snapshot.params.stationame;
            //console.log('  this.stationSlug',   this.stationSlug);
            this.authenticationService.getmetadetail(this.stationSlug).subscribe((resss) => {
                const title = resss.data.meta_title;
                const desc = resss.data.meta_desc;
                this.titleService.setTitle(title);
                this.metaService.addTags([
                    { name: 'description', content: desc },
                ]);
                this.schema = {
                    "@context": "https://schema.org",
                    "@type": "Product",
                    "name": this.stationSlug,
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": resss.data.rating,
                        "ratingCount": resss.data.Ratingcount,
                        "reviewCount": resss.data.Reviewcount,
                    }
                };
                //   let link: HTMLLinkElement = this.doc.createElement('link');
                //   link.setAttribute('rel', 'canonical');
                //   this.doc.head.appendChild(link);
                //  var url = this.doc.URL.replace(/^http:\/\//i, 'https://');
                //  url =  decodeURIComponent(url);
                // console.log(url,decodeURIComponent(window.location.href));
                //   link.setAttribute('href',url);
                let link = this.doc.createElement('link');
                link.setAttribute('rel', 'canonical');
                this.doc.head.appendChild(link);
                let url = this.doc.URL.replace(/^http:\/\//i, 'https://');
                url = decodeURIComponent(url);
                // Remove trailing slash if present (but not if it's just the root "/")
                if (url.length > 1 && url.endsWith('/')) {
                    url = url.slice(0, -1);
                }
                console.log(url, decodeURIComponent(window.location.href));
                link.setAttribute('href', url);
            }, (error) => {
                // console.log('player page');
                this.router.navigate(['/404']);
                this.SpinnerService.hide();
            });
            this.isprevNext = false;
            this.getdetail();
        }
        this.commonService.currentLoader.subscribe(state => {
            this.isloading = state;
        });
        this.commonService.currentDisabled.subscribe(state => {
            this.isDisabled = state;
        });
        this.commonService.currentiserror.subscribe(state => {
            this.isplayerror = state;
        });
        this.commonService.currentispageload.subscribe(state => {
            this.ispageload = state;
        });
        this.commonService.currentisplay.subscribe(state => {
            //  console.log("currentisplay",state);
            this.isplaying = state;
        });
        this.currentMessagesubscription = this.commonService.currentMessage.subscribe(message => {
            if (message) {
                this.activetrack = message.activetrack;
                //console.log("this.activetrack",this.activetrack);
                this.player = message.player;
                //  this.isplaying = message.player.playing();
                if (this.player) {
                    // this.player =  message.player;
                    this.isplaying = message.player.playing();
                }
                else {
                    this.hls = message.hls;
                    this.audio = message.audio;
                    // this.isplaying = message.audio.playing();
                }
            }
        });
        this.currentMessagesubscription = this.commonService.currentTrack.subscribe(message => {
            if (message) {
                this.lasttrack = message.activetrack;
                //  this.activetrack = message.activetrack;
            }
        });
        this.currentMessagesubscription = this.commonService.currentisstartplaying.subscribe(message => {
            if (message) {
                this.currentinprogress = message;
                console.log("this.currentinprogress", this.currentinprogress);
                //  console.log("this.lasttrack",this.lasttrack);
                //  this.activetrack = message.activetrack;
            }
        });
        this.commonService.currentisFav.subscribe(state => {
            // console.log('state',state);
            this.isfav = state;
        });
        this.commonService.currentiscFav.subscribe(state => {
            // console.log('currentiscFav',state);
            if (state) {
                if (isPlatformBrowser(this.platformId)) {
                    this.isfavourite();
                }
            }
        });
        this.commonService.currentvolume.subscribe(state => {
            this.volume = state;
            this.ngvolume = this.volume * 100;
        });
        this.commonService.currentbvolume.subscribe(state => {
            this.bvolume = state;
        });
        this.commonService.currentisnext.subscribe(state => {
            this.isprevNext = state;
            //  console.log("this.isprevNext",this.isprevNext);
        });
        this.commonService.currentisprevNextplaying.subscribe(state => {
            this.isprevNextplaying = state;
            //  console.log("this.isprevNextplaying",this.isprevNextplaying);
        });
    }
    getdetail() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const self = this;
            this.isprevNext = false;
            yield this.homeService.stationDetail(this.stationSlug).subscribe((res) => {
                // console.log('res',res);
                self.stationDetail = res['data'];
                //  console.log('this.stationId', this.stationId);
                if (!res['data'] || res['data'] == 'null') {
                    this.SpinnerService.hide();
                    // console.log('player page stationDetail');
                    this.router.navigate(['/404']);
                    return false;
                }
                self.stationId = res['data'].st_id;
                if (self.stationDetail.website) {
                    let result = self.stationDetail.website.substring(0, 4);
                    if (result == 'http') {
                        self.website = self.stationDetail.website;
                    }
                    else {
                        self.website = 'https://' + self.stationDetail.website;
                    }
                }
                // if(self.stationId && self.stationId == '183651' ){
                // }
                //     const title =  res['data'].meta_title;
                //     const desc =  res['data'].meta_desc;
                //  //   console.log("title",title);
                //     console.log("titdescdescdescle",desc);
                self.isprevNext = false;
                //   //  console.log("this.isprevNex",self.isprevNext);
                //     this.titleService.setTitle(title);
                //     this.metaService.addTags([
                //     {name: 'description', content: desc},
                //   ]);
                // let link: HTMLLinkElement = this.doc.createElement('link');
                // link.setAttribute('rel', 'canonical');
                // this.doc.head.appendChild(link);
                // link.setAttribute('href', this.doc.URL); 
                setTimeout(() => {
                    this.start(res['data']);
                }, 100);
                if (isPlatformBrowser(this.platformId)) {
                    this.isfavourite();
                }
                this.SpinnerService.hide();
                if (!res['data']) {
                    this.router.navigate(['/']);
                }
            }, (error) => {
                this.router.navigate(['/']);
                this.SpinnerService.hide();
            });
        });
    }
    start(track) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const self = this;
            this.commonService.changeCurrentTrack({ 'activetrack': track });
            if (track.status === "200") {
                $("#deactivestation").fadeIn();
                self.isplaying = false;
                if (self.player) {
                    self.player.stop();
                }
                self.pushTrack();
                self.commonService.setLoader(false);
                self.commonService.setDisabled(true);
                self.commonService.setisplayerror(true);
                self.commonService.setisplay(false);
                return;
            }
            //console.log('playerstart', track);
            //console.log(track);
            // if(this.lasttrack && (this.lasttrack.st_id === this.stationId)) {
            //   console.log('sameeeeeeeeeeeeeeeeeeee');
            //   if(this.player) {
            //     console.log('playinggggggggggggggggg');
            //     this.player.stop();
            //     this.commonService.setispageload(true);
            //     this.commonService.setLoader(false);
            //     this.commonService.setDisabled(false);
            //     this.commonService.setisplayerror(false);
            //     return false;
            //   }
            // }
            // if(this.lasttrack && this.activetrack && (this.lasttrack.st_id !== this.activetrack.st_id)){
            //   console.log('not sameeeeeeeeeeeeeeeeeeee');
            //   if(this.player) {
            //     this.player.stop();
            //   }
            // }
            // console.log("this.lasttrack",this.lasttrack);
            //console.log('refreshed?:', browserRefresh);
            //console.log('currentinprogress',this.currentinprogress);
            if (this.currentinprogress && this.currentinprogress.st_id === track.st_id) {
                // console.log('already in progress');
                // this.commonService.setLoader(false);
                //this.commonService.setDisabled(false);
                return false;
            }
            this.commonService.setisprevNextplaying(false);
            this.lastTrack = this.activetrack;
            this.commonService.setLoader(true);
            this.commonService.setDisabled(true);
            this.stationId = track.st_id;
            var stream_link = track.st_link;
            var protocol = stream_link.substr(0, 4);
            var extension = stream_link.slice(-4);
            if (browserRefresh) {
                this.commonService.setispageload(true);
                this.commonService.setLoader(false);
                this.commonService.setDisabled(false);
                this.commonService.setisplayerror(false);
                return false;
            }
            else {
                this.commonService.setispageload(false);
            }
            if (!this.player) {
                this.volume = 1;
                self.bvolume = 1;
                self.ngvolume = 100;
                self.commonService.setvolume(1);
                self.commonService.setbvolume(1);
                //console.log("fisttime play", this.volume);
            }
            //console.log("activetrack", this.activetrack);
            if ((this.activetrack && (this.activetrack.st_id === this.stationId))) {
                // console.log('alredyonplay',this.player);
                //if(!this.player.playing()){
                //  this.player.play();
                // }
                // this.isplaying = true;
                this.commonService.setLoader(false);
                this.commonService.setDisabled(false);
                this.SpinnerService.hide();
            }
            else {
                this.activetrack = track;
                this.isMobile = $(window).width() >= 500;
                this.addtorecent(track);
                // alert("pla122222222222222y");
                if (this.player) {
                    this.player.stop();
                    this.player.unload();
                    this.player = null;
                }
                if (this.hls) {
                    this.hls.destroy();
                    this.hls = null;
                }
                if (extension == 'm3u8') {
                    this.playHls(stream_link);
                    return;
                }
                // var test = /Android/i.test(navigator.userAgent);
                // if(test && (extension == '.pls' || extension == 'm3u8')) {
                //  $("#androidpop").fadeIn();
                // } else {
                //   if (this.isMobile && (extension == '.pls' || extension == 'm3u8')) {
                //     $("#openinApp").fadeIn();
                //     if(this.player) {
                //       this.player.stop();
                //     }
                //     this.commonService.setispageload(true);
                //     this.commonService.setLoader(false);
                //     this.commonService.setDisabled(false);
                //     this.commonService.setisplayerror(false);
                //     return false;
                //   }
                // }
                if (extension == '.pls' || extension == '.m3u') {
                    //console.log('pls');
                    const promise = this.getStream(stream_link);
                    stream_link = yield promise;
                    //console.log('value',stream_link);
                }
                if (protocol == 'http') {
                    //  console.log('http');
                    if (stream_link) {
                        var typeCheck = stream_link.substr(stream_link.length - 4);
                        // 	console.log(typeCheck);
                        var isnum = /^\d+$/.test(typeCheck);
                        if (isnum) {
                            //console.log('isnum');
                            var slashCheck = stream_link.substr(stream_link.length - 1);
                            //	console.log(slashCheck + "slashCheck");
                            if (slashCheck == "/") {
                                stream_link += ";stream/1";
                            }
                            else {
                                stream_link += "/;stream/1";
                            }
                        }
                    }
                    //console.log( isnum );
                }
                else {
                    stream_link = "";
                    // link1		= "Currently not available for playing.";
                }
                //console.log('new play',this.player);
                // var storedNames = JSON.parse(localStorage.getItem("radioApprecent"));
                // if(storedNames) {
                //   var lucky = storedNames.filter(function(number) {
                //     return number.st_id != track.st_id;
                //   });
                // //  console.log('lucky', lucky);
                //  lucky.push(track);
                //  if (lucky.length > 100) {
                //   lucky =  lucky.slice(lucky.length - 100);
                // } else {
                //   //return lucky;
                // }
                //  localStorage.setItem("radioApprecent", JSON.stringify(lucky));
                // } else {
                //  var recents = [];
                //   recents.push(track);
                //   localStorage.setItem('radioApprecent', JSON.stringify(recents));
                // }
                // if ( protocol == 'http' ) {
                //   stream_link = 'https://theonestopradio.com/stream?url='+stream_link;
                // }
                if (stream_link.indexOf("https") == 0) {
                }
                else if (protocol == 'http') {
                    stream_link = 'https://theonestopradio.com/stream?url=' + stream_link;
                }
                // console.log('start',  this.player);
                if (this.player) {
                    this.player.stop();
                    this.player.unload();
                    this.player = null;
                }
                console.log('start', this.player);
                //console.log('start', track);
                console.log('stream_link', stream_link);
                this.player = new Howl({
                    src: stream_link,
                    format: ['mp3', 'aac', 'mpeg', 'opus', 'ogg', 'oga', 'wav', 'caf', 'm4a', 'mp4', 'weba', 'webm', 'dolby', 'flac', 'm3u8'],
                    html5: true,
                    volume: self.volume,
                    headers: {
                        'Accept': 'audio/*',
                        'Authorization': `Bearer`,
                    },
                    onload: () => {
                        if (this.lastTrack && (this.lastTrack.st_id === this.stationId)) {
                            // console.log('this.lastTracgggggggggggggg',this.lastTrack );
                            //console.log("  this.player  this.player  this.player",  this.player);
                            this.player.unload();
                            this.player.stop();
                            // console.log("  this.playersssssssssssss  this.player  this.player",  this.player);
                        }
                        else {
                            this.lastTrack = this.activetrack;
                            self.player.play();
                        }
                        self.pushTrack();
                        //console.log("hjdfgj","ggggggg");
                    },
                    onplay: () => {
                        //console.log("self.volume",self.volume);
                        console.log('onplay');
                        if (self.volume == 0) {
                            //console.log("self.volume",self.volume);
                            self.volume = 1;
                            self.bvolume = 1;
                            self.ngvolume = 100;
                            self.commonService.setvolume(1);
                            self.commonService.setbvolume(1);
                        }
                        if (self.volume == 0.0001) {
                            self.bvolume = 0;
                            self.commonService.setbvolume(0);
                        }
                        self.isplaying = true;
                        self.commonService.setLoader(false);
                        self.commonService.setDisabled(false);
                        self.commonService.setisplayerror(false);
                        self.commonService.setisplay(true);
                        self.pushTrack();
                    },
                    onend: () => {
                        self.isplaying = false;
                        //console.log('onend');
                        self.pushTrack();
                        self.commonService.setLoader(false);
                        self.commonService.setisplayerror(true);
                        self.commonService.setispageload(false);
                        self.commonService.setisplay(false);
                    },
                    onplayerror: function (id, error) {
                        console.log('audio play denied!', error);
                        // self.toaster.open({
                        //   text: 'Please try after sometime.',
                        //   caption: 'Station Not Available',
                        //   type: 'dark',
                        //   position: 'top-right',
                        //   duration: 2000
                        // });
                        $("#errorplay").fadeIn();
                        self.isplaying = false;
                        self.player.stop();
                        self.pushTrack();
                        self.commonService.setLoader(false);
                        self.commonService.setDisabled(true);
                        self.commonService.setisplayerror(true);
                        self.commonService.setispageload(false);
                        self.commonService.setisplay(false);
                    },
                    onloaderror: function (id, error) {
                        console.log('audio play denied! ' + id, error);
                        // self.toaster.open({
                        //   text: 'Please try after sometime.',
                        //   caption: 'Station Not Available',
                        //   type: 'dark',
                        //   position: 'top-right',
                        //   duration: 2000
                        // });
                        $("#errorplay").fadeIn();
                        self.isplaying = false;
                        self.player.stop();
                        self.pushTrack();
                        self.commonService.setLoader(false);
                        self.commonService.setDisabled(true);
                        self.commonService.setisplayerror(true);
                        self.commonService.setispageload(false);
                        self.commonService.setisplay(false);
                    },
                });
            }
        });
    }
    favouites(stationId, state) {
        const self = this;
        if (isPlatformBrowser(this.platformId)) {
            self.user = JSON.parse(sessionStorage.getItem('user')) || null;
        }
        this.authenticationService.authenticated().subscribe((res) => {
            // console.log('suth', res);
            if (res.authenticated === true) {
                this.SpinnerService.show();
                self.playerService.favourite({ 'user_id': self.user.user_id, 'shortcode': stationId }).subscribe((data) => {
                    //console.log('favdata', data);
                    self.isfav = true;
                    self.commonService.setisfav(true);
                    self.SpinnerService.hide();
                    self.authenticationService.favData(self.user.user_id).subscribe((data) => {
                        if (isPlatformBrowser(this.platformId)) {
                            sessionStorage.setItem('favdata', JSON.stringify(data.data));
                        }
                    });
                }),
                    ((error) => {
                        self.SpinnerService.hide();
                        //  self.toastr.error('Something went wrong. Please try again');
                    });
            }
            else {
                self.commonService.setisLogin(true);
                return false;
            }
        }, (error) => {
        });
    }
    unfavouites(stationId, state) {
        const self = this;
        if (isPlatformBrowser(this.platformId)) {
            self.user = JSON.parse(sessionStorage.getItem('user')) || null;
        }
        this.SpinnerService.show();
        self.playerService.favourite({ 'user_id': self.user.user_id, 'shortcode': this.stationId, 'type': 'delete' }).subscribe((data) => {
            // console.log('unfavdata', data);
            self.isfav = false;
            self.commonService.setisfav(false);
            self.SpinnerService.hide();
            self.authenticationService.favData(self.user.user_id).subscribe((data) => {
                if (isPlatformBrowser(this.platformId)) {
                    sessionStorage.setItem('favdata', JSON.stringify(data.data));
                }
            });
        }),
            ((error) => {
                self.SpinnerService.hide();
                // self.toastr.error('Something went wrong. Please try again');
            });
    }
    isfavourite() {
        setTimeout(() => {
            var favdata = JSON.parse(sessionStorage.getItem('favdata')) || [];
            //console.log("favdata",favdata);
            const result = favdata.filter(x => x.id === this.stationId);
            //console.log("result",result);
            if (result.length > 0) {
                //this.isfav =  true;
                this.commonService.setisfav(true);
            }
            else {
                //this.isfav =  false;
                this.commonService.setisfav(false);
            }
            // console.log('result',result);
        }, 20);
    }
    listingData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const self = this;
            setTimeout(() => {
                this.homeService.reco({ st_id: this.stationSlug }).subscribe((res) => {
                    this.popularData = res.data;
                    if (browserRefresh) {
                        // this.alldata =  [ ...self.stationDetail, ...this.popularData]
                        // this.alldata =  self.stationDetail.push(...this.popularData);
                        // this.alldata = this.stationDetail.concat(this.popularData);
                        this.alldata = [].concat(self.stationDetail, this.popularData);
                        let alldata = { "type": "home", "stationtype": 1, index: 1, search: '', genre_id: '', curentpage: '', list: 'home', offset: 1, data: this.alldata, total: this.alldata.length };
                        this.commonService.setcurrentnextplay(alldata);
                        console.log("this.alldata", this.alldata);
                    }
                }, (error) => {
                });
            }, 300);
        });
    }
    getStream(stream_link) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this.homeService.streamLink(stream_link).toPromise();
            return data['data'].stream_link;
        });
    }
    pushTrack() {
        console.log('push', this.player);
        this.commonService.changeMessage({ 'player': this.player, 'activetrack': this.activetrack, 'audio': this.audio, 'hls': this.hls });
    }
    toggelPlayer(event, pause) {
        console.log(this.player, "playerrr");
        event.preventDefault();
        event.stopPropagation();
        if (this.isDisabled) {
            return false;
        }
        this.isplaying = !pause;
        //console.log('this.isplaying ', this.isplaying );
        if (pause) {
            // this.player.pause();
            if (this.player) {
                this.player.pause();
            }
            else {
                this.audio.pause();
            }
            this.commonService.setisplay(false);
        }
        else {
            //this.player.play();
            if (this.player) {
                this.player.play();
            }
            else {
                this.audio.play();
            }
            this.commonService.setisplay(true);
        }
    }
    contsct() {
    }
    redirectTo(data) {
        this.isprevNext = false;
        if (this.stationId !== data.st_id) {
            const self = this;
            if (this.player) {
                this.player.stop();
            }
            else {
                this.audio.pause();
                if (this.hls) {
                    this.hls.destroy();
                }
            }
            // setTimeout(() => {
            let newurl = data.slug;
            // newurl = newurl.replace(/\(/g,"").replace(/\)/g,"");
            //console.log('newurl',newurl);
            self.router.onSameUrlNavigation = 'reload';
            self.router.navigateByUrl(newurl).then(() => {
                self.router.onSameUrlNavigation = 'ignore';
                //this.commonService.setisstartplaying(data);
                self.contsct();
                self.ngOn();
                self.listingData();
            });
        }
        //  }, 1000);
    }
    nFormatter(num) {
        this.isNegative = false;
        if (num < 0) {
            this.isNegative = true;
        }
        num = Math.abs(num);
        if (num >= 1000000000) {
            this.formattedNumber = (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
        }
        else if (num >= 1000000) {
            this.formattedNumber = (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        else if (num >= 1000) {
            this.formattedNumber = (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        else {
            this.formattedNumber = num;
        }
        if (this.isNegative) {
            this.formattedNumber = '-' + this.formattedNumber;
        }
        return this.formattedNumber;
    }
    // showText(){
    //   if (isPlatformBrowser(this.platformId)) {
    //   if(browserRefresh && !this.playstate){
    //     this.commonService.setLoader(true);
    //     this.playstate = true;
    //     setTimeout(() => {
    //      // this.pagestart();
    //         //console.log("showText");
    //       $("#pagestartclass").trigger('click', function(){
    //         //console.log("clicked========");
    //       });
    //     },7000);
    //   }
    //   }
    // }
    dismissModal() {
        $(".modal").fadeOut();
    }
    pagestart() {
        //console.log("pagestart");
        this.commonService.setcurrentStart(true);
    }
    share() {
        $("#sharemodal").fadeIn();
    }
    shareClose() {
        $("#sharemodal").fadeOut();
    }
    genreModal() {
        $("#genreModal").fadeIn();
    }
    genreModalClose() {
        $("#genreModal").fadeOut();
    }
    moreInfo() {
        $(".infoDetail").fadeToggle();
        $(".moreInfo>a").text($(".moreInfo>a").text() == 'More' ? 'Close' : 'More');
    }
    ngOnDestroy() {
        this.commonService.setissearchstate(true);
        if (this.hls) {
            this.hls.destroy();
        }
    }
    store(list, index, data, total) {
        let alldata = { "type": "home", "stationtype": 1, index: index, search: '', genre_id: '', curentpage: '', list: list, offset: index, data: data, total: total };
        this.commonService.setcurrentnextplay(alldata);
        this.commonService.setisnext(false);
    }
    convertCurrentUrlToHttps() {
        // Get the current document URL
        let currentUrl = document.URL;
        // Create a URL object
        let urlObject = new URL(currentUrl);
        // Check if the protocol is "http:"
        if (urlObject.protocol === 'http:') {
            // Change the protocol to "https:"
            urlObject.protocol = 'https:';
        }
        // Return the modified URL as a string
        return urlObject.toString();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            try {
                (window['adsbygoogle'] = window['adsbygoogle'] || []).push({
                    overlays: { bottom: true }
                });
            }
            catch (e) {
                console.error(e);
                $('#playerTopad').hide();
            }
            try {
                (window['adsbygoogle'] = window['adsbygoogle'] || []).push({
                    overlays: { bottom: true }
                });
            }
            catch (e) {
                console.error(e);
                $('#playerAd').hide();
            }
        }, 0);
    }
    playHls(hlsUrl) {
        console.log("hls", hlsUrl);
        const self = this;
        this.hls = new Hls();
        this.audio = new Audio();
        this.hls.config.maxBufferLength = 60; // Increase maximum buffer length to 60 seconds
        this.hls.config.maxBufferSize = 20 * 1024 * 1024; // Increase maximum buffer size to 20 MB
        this.hls.startLevel = 0;
        if (this.player) {
            this.player.stop();
            this.player.unload();
            this.player = null;
        }
        this.hls.loadSource(hlsUrl);
        this.hls.attachMedia(this.audio);
        // this.currentMusic = music;
        // this.$musicState.next({ playing: 'load', music: this.currentMusic, list: this.musicList.length });
        // this.$position.next({ min: '00:00', max: '00:00', val: 0, end: 0 });
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            //this.audio?.play();
            if (this.lastTrack && (this.lastTrack.st_id === this.stationId)) {
                // console.log('this.lastTracgggggggggggggg',this.lastTrack );
                //console.log("  this.player  this.player  this.player",  this.player);
                if (this.player) {
                    this.player.unload();
                    this.player.stop();
                }
                else {
                    this.audio.pause();
                    if (this.hls) {
                        this.hls.destroy();
                    }
                }
                // console.log("  this.playersssssssssssss  this.player  this.player",  this.player);
            }
            else {
                this.lastTrack = this.activetrack;
                this.audio.play();
            }
            this.pushTrack();
        });
        this.hls.on(Hls.Events.ERROR, (event, error) => {
            console.error('HLS error:', error);
            this.pushTrack();
            // this.$musicState.next({ playing: 'pause', music: this.currentMusic, list: this.musicList.length });
            // this.toastr.error(this.msg.wronttryagain);
        });
        this.audio.onplay = () => {
            // console.log('play audio');
            // this.addRecent(music);
            // this.$musicState.next({ playing: 'play', music: music, list: this.musicList.length });
            if (self.volume == 0) {
                //console.log("self.volume",self.volume);
                self.volume = 1;
                self.bvolume = 1;
                self.ngvolume = 100;
                self.commonService.setvolume(1);
                self.commonService.setbvolume(1);
            }
            if (self.volume == 0.0001) {
                self.bvolume = 0;
                self.commonService.setbvolume(0);
            }
            self.isplaying = true;
            self.commonService.setLoader(false);
            self.commonService.setDisabled(false);
            self.commonService.setisplayerror(false);
            self.commonService.setisplay(true);
            self.pushTrack();
        };
        this.audio.onpause = () => {
            // console.log('paused');
            if (this.audio) {
                return;
            }
            // this.$musicState.next({ playing: 'pause', music: this.currentMusic, list: this.musicList.length });
        };
        this.audio.onended = () => {
            //this.$musicState.next({ playing: 'pause', music: this.currentMusic, list: this.musicList.length });
            //this.playNext();
            this.pushTrack();
        };
        this.audio.onerror = () => {
            // console.log('error');
            this.audio.currentTime = 0;
            this.audio.pause();
            //this.toastr.error(this.msg.wronttryagain);
            //this.$musicState.next({ playing: 'pause', music: this.currentMusic, list: this.musicList.length });
            this.pushTrack();
        };
    }
    addtorecent(track) {
        var storedNames = JSON.parse(localStorage.getItem("radioApprecent"));
        if (storedNames) {
            var lucky = storedNames.filter(function (number) {
                return number.st_id != track.st_id;
            });
            //  console.log('lucky', lucky);
            lucky.push(track);
            if (lucky.length > 100) {
                lucky = lucky.slice(lucky.length - 100);
            }
            else {
                //return lucky;
            }
            localStorage.setItem("radioApprecent", JSON.stringify(lucky));
        }
        else {
            var recents = [];
            recents.push(track);
            localStorage.setItem('radioApprecent', JSON.stringify(recents));
        }
    }
}
